import React from 'react';

const HOURS = Array.from({ length: 24 }, (_, index) => String(index).padStart(2, '0'));
const MINUTES = Array.from({ length: 12 }, (_, index) => String(index * 5).padStart(2, '0'));

// munkaóra beállítása
export default function TimePicker({ value = '08:00', onChange, label }) {
  const [hour = '08', minute = '00'] = value.split(':');

  const updateTime = (nextHour, nextMinute) => {
    onChange(`${nextHour}:${nextMinute}`);
  };

  return (
    <div className="flex min-w-0 flex-1 items-center gap-1 font-sans not-italic sm:w-auto sm:flex-none">
      {label && <span className="sr-only">{label}</span>}
      <div className="relative w-0 min-w-0 flex-1 sm:w-16 sm:flex-none">
        <select
          value={hour}
          onChange={(e) => updateTime(e.target.value, minute)}
          aria-label={`${label || 'Idő'} óra`}
          className="w-full appearance-none border-2 border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 dark:text-white rounded-xl p-3 pr-6 text-center font-black text-base outline-none"
        >
          {HOURS.map(item => <option key={item} value={item}>{item}</option>)}
        </select>
        <span className="pointer-events-none absolute right-2 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 border-b-2 border-r-2 border-gray-500 dark:border-gray-400" aria-hidden="true"></span>
      </div>
      <span className="font-black text-gray-400 dark:text-gray-500">:</span>
      <div className="relative w-0 min-w-0 flex-1 sm:w-16 sm:flex-none">
        <select
          value={minute}
          onChange={(e) => updateTime(hour, e.target.value)}
          aria-label={`${label || 'Idő'} perc`}
          className="w-full appearance-none border-2 border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 dark:text-white rounded-xl p-3 pr-6 text-center font-black text-base outline-none"
        >
          {MINUTES.map(item => <option key={item} value={item}>{item}</option>)}
        </select>
        <span className="pointer-events-none absolute right-2 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 border-b-2 border-r-2 border-gray-500 dark:border-gray-400" aria-hidden="true"></span>
      </div>
    </div>
  );
}
